var parent = require('../../../es/string/virtual/trim-right');

module.exports = parent;
